import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Document, Page, View } from '../../compiler'
import { typoStyles } from '../../constants'
import MarkdownText from '../MarkdownText'

const TeamProfileLoading = ({ withoutAttachments = false }) => {
  const pageProps = {
    style: { paddingTop: 64 }
  }

  // DimensionCard Loading Component
  const DimensionCardLoading = () => (
    <View style={{ paddingHorizontal: 24 }}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingHorizontal: 24,
          height: 72,
          backgroundColor: '#fff',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          borderLeftWidth: 1,
          borderTopWidth: 1,
          borderRightWidth: 1,
          borderColor: '#EBF0F5'
        }}
      >
        <View style={{ flexDirection: 'row', alignItems: 'flex-end' }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
            <MarkdownText
              style={[
                typoStyles.H4Black,
                { textTransform: 'uppercase', textAlign: 'left' }
              ]}
            >
              <Skeleton width={150} />
            </MarkdownText>
            <Skeleton width={24} height={24} circle />
          </View>
        </View>
        <View style={{ width: 452 }}>
          <Skeleton height={40} />
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: 8
            }}
          >
            <MarkdownText style={typoStyles.SmallBlack}>
              <Skeleton width={80} />
            </MarkdownText>
            <MarkdownText style={typoStyles.SmallBlack}>
              <Skeleton width={80} />
            </MarkdownText>
          </View>
        </View>
      </View>
      <View
        style={{
          borderTopWidth: 1,
          backgroundColor: '#FAFBFC',
          padding: 24,
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
          borderLeftWidth: 1,
          borderBottomWidth: 1,
          borderRightWidth: 1,
          borderColor: '#EBF0F5'
        }}
      >
        <MarkdownText
          style={[typoStyles.T1Black, { width: '75%', lineHeight: 1.5 }]}
        >
          <Skeleton count={2} />
        </MarkdownText>
      </View>
    </View>
  )

  // DetailedDimensionCard Loading Component
  const DetailedDimensionCardLoading = () => (
    <View style={{ paddingHorizontal: 24 }}>
      <View
        style={{
          backgroundColor: '#fff',
          borderRadius: 8,
          borderWidth: 1,
          borderColor: '#EBF0F5',
          padding: 24
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 16
          }}
        >
          <MarkdownText
            style={[typoStyles.H4Black, { textTransform: 'uppercase' }]}
          >
            <Skeleton width={150} />
          </MarkdownText>
          <Skeleton width={24} height={24} circle />
        </View>
        <View style={{ marginBottom: 16 }}>
          <Skeleton height={40} />
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: 8
            }}
          >
            <Skeleton width={80} />
            <Skeleton width={80} />
          </View>
        </View>
        <MarkdownText style={[typoStyles.T1Black, { lineHeight: 1.5 }]}>
          <Skeleton count={4} />
        </MarkdownText>
      </View>
    </View>
  )

  // CulturalFit Loading Component
  const CulturalFitLoading = ({ withDetails = false }) => (
    <View style={{ marginTop: 16, paddingHorizontal: 24 }}>
      <View
        style={{
          backgroundColor: '#fff',
          borderRadius: 8,
          borderWidth: 1,
          borderColor: '#EBF0F5',
          padding: 24
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 16
          }}
        >
          <MarkdownText
            style={[typoStyles.H4Black, { textTransform: 'uppercase' }]}
          >
            <Skeleton width={200} />
          </MarkdownText>
        </View>
        <View style={{ marginBottom: 16 }}>
          <Skeleton height={300} />
        </View>
        <MarkdownText style={[typoStyles.T1Black, { lineHeight: 1.5 }]}>
          <Skeleton count={withDetails ? 5 : 3} />
        </MarkdownText>
      </View>
    </View>
  )

  // TitleDescription Loading Component
  const TitleDescriptionLoading = () => (
    <View style={{ marginHorizontal: 40 }}>
      <MarkdownText
        style={[
          { display: 'block' },
          typoStyles.H2Black,
          { lineHeight: 1.2, marginBottom: 4 }
        ]}
      >
        <Skeleton width={200} />
      </MarkdownText>
      <MarkdownText
        style={[{ display: 'block' }, typoStyles.T1Black, { lineHeight: 1.2 }]}
      >
        <Skeleton />
      </MarkdownText>
    </View>
  )

  // DiscussionQuestions Loading Component
  const DiscussionQuestionsLoading = () => (
    <View style={{ paddingHorizontal: 40, marginTop: 16 }}>
      <View
        style={{
          backgroundColor: '#F5F7FA',
          borderRadius: 8,
          borderWidth: 1,
          borderColor: '#EBF0F5',
          padding: 16
        }}
      >
        <MarkdownText
          style={[
            typoStyles.T2MediumBlue,
            { textTransform: 'uppercase', marginBottom: 12 }
          ]}
        >
          <Skeleton width={150} />
        </MarkdownText>
        {[1, 2, 3].map((_, index) => (
          <View key={index} style={{ marginTop: index > 0 ? 8 : 0 }}>
            <Skeleton width='90%' />
          </View>
        ))}
      </View>
    </View>
  )

  return (
    <Document>
      {/* FÄHIGKEITEN */}
      <Page>
        <View>
          <TitleDescriptionLoading />
          <View style={{ marginTop: 26.5 - 16 }} />
          {[1, 2, 3].map((_, index) => (
            <View key={index} style={{ marginTop: 16 }}>
              <DimensionCardLoading />
            </View>
          ))}
        </View>
      </Page>

      {/* PERSÖNLICHKEIT */}
      <Page {...pageProps}>
        <View>
          <TitleDescriptionLoading />
          <View style={{ marginTop: 26.5 - 16 }} />
          {[1, 2, 3, 4, 5].map((_, index) => (
            <View key={index} style={{ marginTop: 16 }}>
              <DimensionCardLoading />
            </View>
          ))}
        </View>
      </Page>

      {/* KULTUR */}
      <Page {...pageProps}>
        <View>
          <TitleDescriptionLoading />
          <CulturalFitLoading />
        </View>
      </Page>

      {/* INTERESTS */}
      <Page {...pageProps}>
        <View>
          <TitleDescriptionLoading />
          <View style={{ marginTop: 26.5 - 16 }} />
          {[1, 2, 3].map((_, index) => (
            <View key={index} style={{ marginTop: 16 }}>
              <DimensionCardLoading />
            </View>
          ))}
        </View>
      </Page>

      {/* ATTACHMENTS SECTION */}
      {!withoutAttachments && (
        <>
          {/* FÄHIGKEITEN - DETAILED */}
          <Page {...pageProps}>
            <TitleDescriptionLoading />
            <View style={{ marginTop: 10 }} />
            {[1, 2, 3].map((_, index) => (
              <View key={index} style={{ marginTop: 16 }}>
                <DetailedDimensionCardLoading />
              </View>
            ))}
          </Page>

          {/* PERSÖNLICHKEIT - DETAILED */}
          <Page {...pageProps}>
            <TitleDescriptionLoading />
            <View style={{ marginTop: 10 }} />
            {[1, 2, 3, 4, 5].map((_, index) => (
              <View key={index} style={{ marginTop: 16 }}>
                <DetailedDimensionCardLoading />
              </View>
            ))}
          </Page>

          {/* KULTUR - DETAILED */}
          <Page {...pageProps}>
            <View>
              <TitleDescriptionLoading />
              <CulturalFitLoading withDetails />
            </View>
          </Page>

          {/* BERUFLICHE INTERESSEN - DETAILED */}
          <Page {...pageProps}>
            <TitleDescriptionLoading />
            <DiscussionQuestionsLoading />
            <View style={{ marginTop: 10 }} />
            {[1, 2, 3].map((_, index) => (
              <View key={index} style={{ marginTop: 16 }}>
                <DetailedDimensionCardLoading />
              </View>
            ))}
          </Page>
        </>
      )}
    </Document>
  )
}

export default TeamProfileLoading
